/** @jsx h */
import { labels } from '../config';
import { $, $$ } from 'utils/dom';
import { useRef, useEffect, useState } from 'preact/hooks';
import { DatePicker } from '../../form/form';

/** @jsx h */
const DateContainer = ({ facets, pluginNamespace, triggerAjaxSubmit }) => {
  let dateFilterObj = null;
  for (let i = 0; i < facets.length; i++) {
    if (facets[i].type === 'dateRange') {
      dateFilterObj = facets[i];
      break;
    }
  }
  const [startDate, setStartDate] = useState('');
  const [dateInput, setDateInput] = useState('');
  const [endDate, setEndDate] = useState('');
  const datepickerInputEl = useRef(null);
  const datepickerReset = useRef(null);
  const datePickerClasses = [];

  function resetDatepicker() {
    setDateInput('');
    setStartDate('');
    setEndDate('');

    const dateContainer = $('.search-section__dates');
    const flatpickrInputs = $$('.flatpickr-input', dateContainer);
    const hiddenDatepickerInput = $('#dateRangePicker', dateContainer);

    if (hiddenDatepickerInput) hiddenDatepickerInput.value = '';

    if (!flatpickrInputs.length) return;
    flatpickrInputs.forEach(flatpickrInput => {
      flatpickrInput.value = '';
    });
  }

  useEffect(() => {
    datepickerReset.current = resetDatepicker;
  }, []);

  useEffect(() => {
    // Datepicker
    const dateContainer = $('.search-section__dates');
    if (dateContainer) {
      const flatpickrSelector = '[data-flatpickr]:not(:disabled)';

      const dateInputs = Array.from(
        $$(flatpickrSelector, dateContainer)
      ).filter(el => !el.querySelector(':disabled'));

      dateInputs.forEach(el => {
        const datepickerClass = new DatePicker(el, {
          onChange: (_, dateStr) => {
            const dateType = el.dataset.type;
            const dateString = dateStr.replaceAll('-', '');

            if (dateType === 'start') {
              const startRangeString = dateFilterObj.options.rangeMin.date
                .substring(0, dateFilterObj.options.rangeMin.date.indexOf(' '))
                .replaceAll('-', '');
              const startDateString =
                dateStr !== ''
                  ? `${dateString}0000-`
                  : `${startRangeString}0000-`;

              setStartDate(startDateString);
            } else {
              const endRangeString = dateFilterObj.options.rangeMax.date
                .substring(0, dateFilterObj.options.rangeMax.date.indexOf(' '))
                .replaceAll('-', '');
              const endDateString =
                dateStr !== '' ? `${dateString}2359` : `${endRangeString}2359`;

              setEndDate(endDateString);
            }
          },
        });
        datepickerClass.init();

        datePickerClasses.push(datepickerClass);
      });

      // catch empty min attribute
      $$('[data-min-date-element-id]', dateContainer).forEach(el => {
        const minDateElementId = el.dataset.minDateElementId;
        if (minDateElementId) {
          $(`input#${minDateElementId}`, dateContainer).addEventListener(
            'change',
            e => {
              el.setAttribute('min', e.target.value);
            }
          );
        }
      });
    }
  }, []);

  useEffect(() => {
    // if startDate was set, but not endDate, use rangeMax as endDate
    // else if startDate was NOT set, but endDate was, use rangeMin as startdDate
    if (startDate && !endDate) {
      // remove time data from string (after space) and remove unwanted '-'
      const endDateString = dateFilterObj.options.rangeMax.date
        .substring(0, dateFilterObj.options.rangeMax.date.indexOf(' '))
        .replaceAll('-', '');
      const dateString = `${startDate}${endDateString}2359`;
      setDateInput(`${dateFilterObj.name}:${dateString}`);
    } else if (!startDate && endDate) {
      // remove time data from string (after space) and remove unwanted '-'
      const startDateString = dateFilterObj.options.rangeMin.date
        .substring(0, dateFilterObj.options.rangeMin.date.indexOf(' '))
        .replaceAll('-', '');
      const dateString = `${startDateString}0000-${endDate}`;

      setDateInput(`${dateFilterObj.name}:${dateString}`);
    } else if (startDate && endDate) {
      const endDateIsBeforeStartDate = +startDate.replace('-', '') >= +endDate;

      // if enddate is before startdate, reset datepicker inputfields and prevent form submit
      if (endDateIsBeforeStartDate) {
        resetDatepicker();
      } else {
        const dateString = `${startDate}${endDate}`;

        setDateInput(`${dateFilterObj.name}:${dateString}`);
      }
    }
  }, [startDate, endDate]);

  useEffect(() => {
    // do nothing if dateInput is empty
    if (dateInput === '') return;

    triggerAjaxSubmit();
  }, [dateInput]);

  return (
    <div className="search-section__dates">
      <p className="search-section__category-name">
        {labels.faceting.datepickerDate}
      </p>
      <div className="search-section__dates__wrapper">
        <label for="dateRangePicker" className="sr-only">
          <input
            id="dateRangePicker"
            name={`${pluginNamespace}[filter][]`}
            type="text"
            readonly
            ref={datepickerInputEl}
            value={dateInput}
          />
        </label>
        <div
          className="search-section__date"
          data-flatpickr
          data-flatpickr-type="date"
          data-type="start"
        >
          <label for="search-start-date" class="input__label is-smaller">
            {labels.faceting.datepickerFrom}
          </label>
          <input
            className="input input--date is-link flatpickr-input"
            type="text"
            id="search-start-date"
            name="search-start-date"
            data-input
            data-min-date-element-id="search-start-date"
            min="2023-01-01"
            max="2030-01-01"
          />
        </div>
        <div
          className="search-section__date"
          data-flatpickr
          data-flatpickr-type="date"
          data-type="end"
        >
          <label for="search-end-date" class="input__label is-smaller">
            {labels.faceting.datepickerUntil}
          </label>
          <input
            className="input input--date is-link flatpickr-input"
            type="text"
            id="search-end-date"
            name="search-end-date"
            data-input
            data-min-date-element-id="search-end-date"
            min="2023-01-01"
            max="2030-01-01"
          />
        </div>
      </div>
    </div>
  );
};

export default DateContainer;
